import * as fromDatatype from "../datatype-library/index";

export interface bl_ppl_ap_testbed_sending_doc_event_RowInterface {
	guid: fromDatatype.GuidDataFieldInterface;
	sending_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
	event_time: fromDatatype.TimestampTzDatatypeInterface;
	action: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	event_status: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_by_name: fromDatatype.VarcharDatatypeInterface;
	updated_by_name: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_ppl_ap_testbed_sending_doc_event_RowClass
	implements bl_ppl_ap_testbed_sending_doc_event_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	sending_doc_hdr_guid: fromDatatype.GuidDataFieldInterface;
	event_time: fromDatatype.TimestampTzDatatypeInterface;
	action: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	event_status: fromDatatype.VarcharDatatypeInterface;
	property_json: any;
	namespace: fromDatatype.VarcharDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_by_name: fromDatatype.VarcharDatatypeInterface;
	updated_by_name: fromDatatype.VarcharDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
